import { Roles } from 'clickNgo/configs/roles'
import { IAudienceCondition } from 'core/components/shared/ui/VisualAudienceExtended'

export const getSuperAdminAudienceAccess = (): IAudienceCondition => ({
  UserRoles: [Roles.SUPER_ADMIN_ROLE],
})
